import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

// Preloader styled component
export const PreloaderContainer = styled(Box)({
  position: 'fixed',
  top: 0,
  left: 0,
  zIndex: 1000,
  width: '100%',
  height: '100%',
  backgroundColor: '#0c0513',
  backgroundImage: 'url(src/Assets/pre.svg)',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
});
